/**
 * helper that'll extract the content from the DOM, so we can easily intercept
 * the actually applied HTML code.
 */
function extractTextComponentHtml(componentRef, selectorAttribute) {
  if (!componentRef) {
    return "";
  }

  // extract reference to the textual content by navigating up to the component
  // wrapper node, and then finding the ".gText__expanded" container inside
  let componentWrapper = componentRef;
  while (componentWrapper && !componentWrapper.hasAttribute(selectorAttribute)) {
    componentWrapper = componentWrapper.parentElement;
  }
  return componentWrapper?.innerHTML ?? "";
}

export { extractTextComponentHtml };
//# sourceMappingURL=extractTextComponentHtml.js.map
